module.exports = __webpack_public_path__ + "img/Barbell.e40099ea.png";